import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface DashboardMiddleHeatingProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function DashboardMiddleHeating(props: DashboardMiddleHeatingProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Dashboard Middle Heating"
      width={37}
      height={374}
      viewBox="0 0 37 374"
      position={{top: 64, left: 447}}
    >
      <path
        d="M23 363C23 367 13 373 6 373H1V1H6C13 1 23 7 23 11V121C23 133 23 136 28 143C33.4834 150.677 36 148 36 168V187V206C36 226 33.4834 223.323 28 231C23 238 23 241 23 253V363Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M23 363C23 367 13 373 6 373H1V1H6C13 1 23 7 23 11V121C23 133 23 136 28 143C33.4834 150.677 36 148 36 168V187V206C36 226 33.4834 223.323 28 231C23 238 23 241 23 253V363Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="21"
        y="171"
        width="11"
        height="11"
        rx="5.5"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="21"
        y="192"
        width="11"
        height="11"
        rx="5.5"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="24"
        y="174"
        width="5"
        height="5"
        rx="2.5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="24"
        y="195"
        width="5"
        height="5"
        rx="2.5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M6.00001 47V9.00001L8.00001 9C17 9 18 12 18 18L17.9999 28L18 38C18 44 17 47 8.00001 47H6.00001Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M9 8.99999V47"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M12 8.99999V47"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M15 9.99999L15 46"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M6 28H18"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M6.00001 47V9L8.00001 8.99999C17 8.99999 18 12 18 18L17.9999 28L18 38C18 44 17 47 8.00001 47H6.00001Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M6.00001 327V365L8.00001 365C17 365 18 362 18 356L17.9999 346L18 336C18 330 17 327 8.00001 327H6.00001Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path d="M9 365V327" stroke="currentColor" className={partStroke({variant: props.variant})} />
      <path
        d="M12 365V327"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M15 364L15 328"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M6 346H18"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M6.00001 327V365L8.00001 365C17 365 18 362 18 356L17.9999 346L18 336C18 330 17 327 8.00001 327H6.00001Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
